import { ColorHexCodes } from "./Color";

export const StyleDict = {
  Bold: { fontWeight: "bold" },
  ReservationCompleted: { fontSize: 20, fontWeight: "bold", color: `#${ColorHexCodes.MainColorGreen}` },
  ReservationCompletedMessage: { fontSize: 15, color: `#${ColorHexCodes.MainColorGreen}` },
  StoreMessage: { color: `#${ColorHexCodes.MainColorGreen}`, whiteSpace: "pre-line", minHeight: "3.0em" },
  Required: { color: "white", fontSize: "14px", backgroundColor: `#${ColorHexCodes.RequiredRed}`, borderRadius: 8, padding: "4px 8px" },
  Optional: { color: "white", backgroundColor: `#${ColorHexCodes.Gray}`, borderRadius: 8, padding: "2px 8px" },
  TimeTableDay: { fontSize: 14, margin: "0px" },
  NoMargin: { margin: "0px" },
  CancelText: { color: `#${ColorHexCodes.MainColorGreen}` },
};

export type TextStyle = keyof typeof StyleDict;
